import React, {useReducer, useState} from "react";
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormGroup,
    FormControlLabel,
    Checkbox
} from "@mui/material";

import Typography from "@mui/material/Typography";
import MDLoadingButton from "../../MDLoadingButton";
import MDButton from "materialDashboard/components/MDButton";


const ConfirmationDialog = props => {
    const {options, onClose} = props;
    const [isLoading, setLoading] = useState(false);
    const [doNotAskMeLater, toggleDoNotAskMeLater] = useReducer((state) => !state, options.defaultDoNotAskMeLater);

    const handleClose = () => {
        if (options && options.disableClose) {
            return;
        }

        if (isLoading) {
            return;
        }

        onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        try{
            await options.onConfirm({doNotAskMeLater});
            onClose();
        } catch (e) {
            setLoading(false);
            throw e;
        }
    };

    return (
        <Dialog open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth>

            <DialogTitle id="alert-dialog-title">
                {options.title}
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="text" id="alert-dialog-description" component="div">
                    {options.description}
                </Typography>
                {
                    options.showDoNotAskMeLater &&
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={doNotAskMeLater} onChange={toggleDoNotAskMeLater} />}
                                          label={<Typography color="text.secondary">{options.doNotAskMeLaterMessage}</Typography>}/>
                    </FormGroup>
                }
            </DialogContent>

            <DialogActions sx={{p: 2}}>
                {
                    options && !options.disableClose &&
                    <MDButton color="secondary"
                              variant="text"
                              onClick={handleClose}>
                        {options.cancellationText}
                    </MDButton>
                }
                <Box sx={{m: 1}}>
                    <MDLoadingButton color="primary"
                                   variant="contained"
                                   onClick={handleConfirm}
                                   loading={isLoading}>
                        {options.confirmationText}
                    </MDLoadingButton>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export {ConfirmationDialog}